import React from 'react';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { Utils } from '../../Utils';

import './Shops.css'; 

class Shops extends React.Component {

  animationObjectRef = new React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      hiding: false,
      shops: [],
      show: false,
    };
  }

  show() {
    Utils.get_server_data(
      '',
      {
        ajax_event:'shops',
        APICACHE:'false'
      }, 
      {
        ajax_event: 'shops',
        formData: JSON.stringify({}),
      }
    )
    .then((res)=>{
      this.setState({shops: res.shops, show: true});
    });
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  toggle_div_open(shop_id) {
    const { shops } = this.state;

    shops.forEach(shop => {
      if (parseInt(shop.id) === parseInt(shop_id)) {
        shop.div_open = parseInt(shop.div_open) === 1 ? 0 : 1;
      }
    });

    this.setState({shops});
  }

  render() {
    const { show, hiding, shops } = this.state;

    if (!show) return '';

    return  <div className={`container floating_container page_shops ${hiding ? 'out' : ''}`}>
    <div className="content">
      
      <PageHeader parent_ref={this} title={i18n.t('shopsTitle')} />
      
      <div className='container_inner'>
        {!!shops ? 
          shops.map((shop) => {
            return <div key={`shop_${shop.id}`} className={`shop ${parseInt(shop.div_open) === 1 ? 'open' : ''}`}>
              <h3 onClick={(e) => this.toggle_div_open(shop.id)}>{shop.label}<span className="toggler">{parseInt(shop.div_open) === 1 ? '-' : '+'}</span></h3>
              <div className="details">
                <div className="address">{shop.address}</div>
                <div className="address">
                  <label>{i18n.t('shopsPhone')}</label>
                  <span>
                    <a href={`tel:${shop.phone}`}>{shop.phone}</a>
                  </span>
                </div>
                <div className="opening">
                  <label>{i18n.t('shopsOpening')}</label>
                  <span dangerouslySetInnerHTML={{__html: shop.openhours}}></span>
                </div>
                {shop.image ? <div className="image">
                  <img src={`${process.env.REACT_APP_ORIGINAL_SHOP_URL}/upload_files/uzletek/${shop.image}`} />
                </div> : ''}
              </div>
            </div>
          })
        : ''}
      </div>

      </div>
    </div>;
  }
}

export default Shops;